/* eslint-disable @typescript-eslint/naming-convention */
import { gql } from '@lcs/shared/api';

export const SaveHardphoneMutation = gql`
   mutation SaveHardphone($phone: PhoneInput!) {
      phone: savePhone(phone: $phone) {
         phoneId
         phoneType
         extensionId
         devicesConnection {
            items {
               macAddress
               deviceId
               phoneId
            }
         }
      }
   }
`;
